export default {"src":"/_next/static/media/x.0ee138f0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};